<template>
  <v-dialog v-model="dialogVisible" max-width="850px">
    <v-card class="pa-2">
      <v-card-title class="text-h6 d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-receipt-text-outline</v-icon>
        Orders for {{ customer?.name }} {{ customer?.lastName }}
      </v-card-title>
      <v-card-text>
        <div v-if="loading" class="text-center py-8">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else-if="orders.length === 0" class="text-center py-8 text-medium-emphasis">
          No orders found for this customer.
        </div>
        <v-data-table
          v-else
          :headers="headers"
          :items="orders"
          :items-per-page="10"
          density="comfortable"
        >
          <template #item.orderNumber="{ item }">
            {{ item.orderNumber }}
          </template>
          <template #item.event="{ item }">
            {{ item.event?.occasion }} ({{ formatDate(item.event?.date) }})
          </template>
          <template #item.menuName="{ item }">
            {{ item.menuName }}
          </template>
          <template #item.numberOfGuests="{ item }">
            {{ item.numberOfGuests }}
          </template>
          <template #item.totalCost="{ item }">
            ${{ formatCurrency(item.totalCost) }}
          </template>
          <template #item.orderStatus="{ item }">
            {{ formatStatus(item.orderStatus) }}
          </template>
          <template #item.actions="{ item }">
            <v-btn size="small" color="primary" variant="text" @click="goToOrder(item)">View Order</v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { orderService } from '../services';
import { formatDate, formatCurrency } from '../utils/index.js';

export default {
  name: 'CustomerOrdersModal',
  props: {
    customer: { type: Object, default: null },
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      orders: [],
      loading: false,
      headers: [
        { title: 'Order #', value: 'orderNumber' },
        { title: 'Event', value: 'event' },
        { title: 'Menu', value: 'menuName' },
        { title: 'Guests', value: 'numberOfGuests' },
        { title: 'Total', value: 'totalCost' },
        { title: 'Status', value: 'orderStatus' },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    show(newVal) {
      if (newVal && this.customer) {
        this.fetchCustomerOrders();
      }
    },
  },
  methods: {
    async fetchCustomerOrders() {
      this.loading = true;
      try {
        const data = await orderService.getCustomerOrders(this.customer.id);
        this.orders = data.data || [];
      } catch (err) {
        console.error('Failed to fetch customer orders:', err);
        this.orders = [];
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.$emit('close');
    },
    goToOrder(order) {
      this.$router.push({
        name: 'CustomerOrderView',
        params: {
          customerId: this.customer.id,
          orderId: order.id
        }
      });
    },
    formatDate,
    formatCurrency,
    formatStatus(status) {
      const statusMap = {
        pending: 'Pending',
        confirmed: 'Confirmed',
        in_progress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
      };
      return statusMap[status] || status;
    },
  },
};
</script>

<style scoped>
:deep(.v-data-table-header) {
  background-color: #f8fafc;
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
  color: #64748b !important;
}
</style> 